import { InputButton } from '@homestake/shared/ui';
import { use$ } from '@legendapp/state/react';
import { Group } from '@mantine/core';
import {
  autoBetState$,
  configurationState$,
  manualBetState$,
} from '../../state';
import { freeBetState$ } from '../../state/free-bet.state';

export type PredefinedBetsProps = {
  onClick: (bet: number) => void;
};

export const PredefinedBets = ({ onClick }: PredefinedBetsProps) => {
  const predefinedBets = use$(configurationState$.predefinedBets);
  const currency = use$(configurationState$.currency);
  const isManualBetting = use$(manualBetState$.isBetting);
  const isAutoBetting = use$(autoBetState$.isAutoBetting);
  const isFreeBetting = use$(freeBetState$.isActive);

  return (
    <Group gap={4} justify="flex-end">
      {predefinedBets.map((bet) => (
        <InputButton
          data-test-id={`predefined-bet-button-${bet}`}
          disabled={isManualBetting || isAutoBetting || isFreeBetting}
          isLight
          key={bet}
          onClick={() => onClick(bet)}
          size="compact-xs"
        >
          {bet} {currency}
        </InputButton>
      ))}
    </Group>
  );
};
